module.exports = __webpack_public_path__ + "img/logo-light.c7d8565a.svg";